/* eslint-disable prettier/prettier */
/* eslint-disable no-control-regex */
import type { IsRequiredValue } from '../validation';
import * as validation from '../validation';

export enum FormErrorCode {
  Required = 'This field is required!',
  Email = 'Email is not correct!',
  ZipCode = 'Invalid zip code!',
  CreditCard = 'Invalid credit card number!',
  CVC = 'CID of credit card needs to be a minimum of 3 characters long!',
  PhoneNumber = 'Invalid phone number!',
  StreetAddress = 'Enter a street address to get your package faster',
  EnglishAlphabet = 'Please use English alphabet!',
  Alphabet = 'Please use only alphabet!',
}

export type ValidatorType = (value: any) => string | FormErrorCode | undefined;

export const compose =
  (...validators: Array<ValidatorType> | Array<undefined>) =>
  (value: unknown) => {
    for (const validator of validators) {
      if (!validator) continue;
      const res = validator(value);
      if (res !== undefined) {
        return res;
      }
    }
    return undefined;
  };

export const required = (value: IsRequiredValue) => validation.isRequired(value) ? undefined : FormErrorCode.Required;

export const email = (value?: string) => validation.isEmail(value) ? undefined : FormErrorCode.Email;

export const zipCode = (isoCountryName?: string) => (value?: string) =>
  validation.isZipCode(isoCountryName, value?.trim()) ? undefined : FormErrorCode.ZipCode;

export const creditCard = (value?: string) => (validation.isCreditCard(value) ? undefined : FormErrorCode.CreditCard);

export const cvc = (value?: string) => (validation.isCVC(value) ? undefined : FormErrorCode.CVC);

export const hasStreetAddress = (value?: string) =>
  validation.streetAddress(value) ? undefined : FormErrorCode.StreetAddress;

export const phoneNumber = (value?: string) =>
  validation.isPhoneNumber(value) ? undefined : FormErrorCode.PhoneNumber;

export const hasPOBoxAddress = (value?: string) =>
  validation.isPoBoxAddress(value) ? undefined : FormErrorCode.StreetAddress;

export const ascii = (callBack: () => void, alertMessage: string) => (value?: string) => {
  if (value) {
    const regExp: RegExp = /[\u0400-\u04FF]+$/;
    const isEnglish = regExp.test(value);

    if (!isEnglish) return undefined;

    callBack();
    window.alert(alertMessage);
    return FormErrorCode.Alphabet;
  }

  return undefined;
};

//English letters only
export const isASCII = (value: string) => /^[\x00-\x7F]*$/.test(value);

export const onlyFloatAndInteger = (val: string): boolean => {
  // Only allow numbers and floats
  const regex = /^\d*\.?\d{0,2}$/;
  return regex.test(val);
};
